import { FirebaseData } from "../General/FirebaseData";
import { LocalData } from "../General/LocalData";
import { UserData } from "../User/UserData";

export class CompanyMemberData extends FirebaseData {
  user: UserData;
  admin: boolean = false;
  hasAutoAccess: boolean = false;

  constructor(id: string, collectionName: string, parent: FirebaseData | undefined) {
    super(id, collectionName, parent);
    this.user = LocalData.users.addData(id);
  }

  setup(data: any) {
    this.admin = typeof data.admin === "boolean" ? data.admin : false;
    this.hasAutoAccess = typeof data.hasAutoAccess === "boolean" ? data.hasAutoAccess : false;
    super.setup(data);
  }
}
